import { useQuery } from '@tanstack/react-query';

import { fetchUserApiKeys } from '@/api/v4/user-api-key.api';
import { QueryKey } from '@/config/query-client';
import { PRODUCT } from '@/user/products/product.type';
import { useUserProducts } from '@/user/products/use-user-products';

export const useUserApiKeys = () => {
  const { hasRequiredProduct } = useUserProducts();

  return useQuery({
    queryKey: [QueryKey.UserApiKeys],
    queryFn: fetchUserApiKeys,
    enabled: hasRequiredProduct(PRODUCT.PERSONAL_ACCESS_TOKEN),
  });
};
